import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { documentsActions } from '../store/actions';
// import { Document, Page } from 'react-pdf'

import {
    Button,
    useMediaQuery,
    Dialog,
    Typography,
    CircularProgress,useTheme
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// import { mainStyles } from '../styles'
import { ListElement } from './ListElement'
import VisorPDF from "./Visor/VisorPDF.js";
import { useTranslation } from 'react-i18next';

export const DocButton = ({ name, approved, docStatus, id }) => {
    const [open, setOpen] = useState(false);
    const [pages, SetnumPages] = useState([]);
    const dispatch = useDispatch()
    const document = useSelector(state => state.DocumentView)
    const matches = useMediaQuery('(min-width:750px)');
    const gridContainer = {} //mainStyles.gridStyle()
    const visualDoc = {} //mainStyles.docVisualButton()
    const { t } = useTranslation();

    const handleClickOpen = () => {
        SetnumPages([])
        dispatch(documentsActions.GetDocument(id))
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const setPages = ({ numPages }) => {
        for (let i = 1; i < numPages + 1; i++) {
            SetnumPages(pages => [...pages, i])
        }
    }

    useEffect(() => {
        // console.log('num pages', pages)
    }, [pages])

    useEffect(() => {
        // console.log('document', document)
    }, [document])
    return (
        <div className={visualDoc.visualButtonSection}>
            <Button
                className={gridContainer.buttonList}
                key={'btn_key_docs'}
                onClick={handleClickOpen}
            >
                <ListElement
                    key={'list_element_key_docs'}
                    text={name}
                    statusColor={docStatus}
                    status={approved} />
            </Button>
            <Dialog fullScreen open={open} onClose={handleClose} className={matches && gridContainer.container}>

                <div className={gridContainer.centerColumn}>
                    <ArrowBackIcon
                        style={{ alignSelf: 'flex-start', marginTop: 15, marginLeft: 15 }}
                        onClick={handleClose} />
                    <div className={visualDoc.titleSection}>
                        <Typography variant='h6' className={visualDoc.title}>{name}</Typography>
                    </div>
                    <div className={document.loading ? visualDoc.loading : visualDoc.docView}>
                        {
                            document.loading
                                ? <CircularProgress color="primary" size="150px" /> :
                                document.extension === '.mp4' ?
                                    <video className="videoClass" width="100%" height="90%" controls autoplay loop poster="fotograma.png">
                                        <source src={document.items} type={document.type} />
                                        <p>{t("unsupported_browser_message")}</p>
                                    </video>
                                    : (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i)) ?
                                        <VisorPDF pdfUrl={document.items} pdfName={name ?? ""}
                                            height="100vh" />
                                        : <object width="100%" height="100%" data={document.items} type='application/pdf' />
                            // <object className={gridContainer.visorContentPrinc} >
                            //         <embed id="pdfID" className={gridContainer.pdfContentCenter}
                            //             src={`${document.items}#toolbar=0&navpanes=0&scrollbar=0&view=FitH&zoom=35`} />
                            //      </object>

                            // <VisorPDF pdfUrl={document.items} />
                            // document.extension === '.pdf' && navigator.userAgent.match(/iPhone/i)
                            //     ? <object className={gridContainer.visorContentPrinc} >
                            //         <embed id="pdfID" className={gridContainer.pdfContentCenter}
                            //             src={`${document.items}#toolbar=0&navpanes=0&scrollbar=0&view=FitH&zoom=35`} />
                            //     </object>
                            //     // <object width="100%" height="100%" data={document.items} type={document.type} />
                            //     : document.extension === '.pdf' && matches
                            //         ? <object width="100%" height="100%" data={document.items} type={document.type} />
                            //         : document.extension === '.pdf'
                            //             && (navigator.userAgent.match(/Android/i) || !matches)
                            //             && name.includes('frame')
                            //             ? <VisorPDF pdfUrl={document.items} />
                            //             : document.extension === '.pdf'
                            //                 && ((navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i)) || !matches)
                            //                 ? <VisorPDF pdfUrl={document.items} />
                            //                 : ''
                        }
                    </div>

                </div>
            </Dialog>
        </div>
    )
}